import { useEffect } from "react";
import BgHolder from "./BgHolder";
import UtilAnalytics from "./Analytics";
import useSeasonDetails from "../hooks/useSeasonDetails";

const DEFAULT_HEADER = "/images/header/entencup-2026-edit.jpg";
const DEFAULT_HEADER_MOBILE = "/images/header/entencup-2026-edit-small.jpg";

function PageRenderer({ pageName, analyticsPath }) {
    const { data } = useSeasonDetails();

    useEffect(() => {
        UtilAnalytics.page(analyticsPath || `/${pageName.toLowerCase()}`);
    }, [pageName, analyticsPath]);

    const page = data?.pages?.[pageName];
    const bands = page?.bands || [];
    const mainImage = page?.mainImage || DEFAULT_HEADER;
    const mainImageMobile = page?.mainImageMobile || DEFAULT_HEADER_MOBILE;

    return (
        <div>
            <BgHolder mainImage={mainImage} mainImageMobile={mainImageMobile} bands={bands} />
        </div>
    );
}

export default PageRenderer;
